<template>
  <div class="online-wrap">
    <div class="online-navbar">
      <div class="align-left-navbar">
        <span @click="closeOnline" class="gray material-icons"
          >keyboard_backspace</span
        >
        <span>{{ $t("chat.onlineParticipants") }}</span>
      </div>
      <div class="align-right-navbar">
        <span @click="closeOnline" class="gray material-icons">clear</span>
      </div>
    </div>
    <div class="online-navbar-filler"></div>
    <div class="everyone-wrap" v-if="onlinePeople">
      <div class="title">Online people</div>
      <!-- person.imageURL is in key because it changes async so it has to rerender list when i get the images -->
      <div
        v-for="person in onlinePeople"
        :key="person.usr_id"
        class="person-wrap"
        @click="goToChat(person)"
      >
        <div class="icon-dot">
          <div class="img-wrap">
            <img :src="person.imageURL" draggable="false" />
          </div>
          <div class="green-dot"></div>
        </div>
        <span>{{ person.usr_firstname }} {{ person.usr_lastname }}</span>
      </div>
      <div class="title">Available people</div>
      <div
        v-for="person in availablePeople"
        :key="person.usr_id"
        class="person-wrap"
        @click="goToChat(person)"
      >
        <div class="icon-dot">
          <div class="img-wrap">
            <img
              class="frame"
              :src="
                imageBaseUrl +
                'api/users/' +
                'pictureframe?rol_id=' +
                person.rol_id +
                '&type=circle' +
                '&sid=' +
                sid
              "
              alt=""
            />
            <img :src="person.imageURL" draggable="false" />
          </div>
          <div class="orange-dot"></div>
        </div>
        <span>{{ person.usr_firstname }} {{ person.usr_lastname }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      onlinePeople: null,
      availablePeople: null,
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
    };
  },
  computed: {
    sid() {
      return localStorage.getItem("sid");
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      let res;
      try {
        this.startLoading();
        res = await api.getAllOnline();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.stopLoading();
      }
      res = res.data;
      delete res["result"];
      this.onlinePeople = res.Online;
      this.availablePeople = res.Available;
      // console.log(this.onlinePeople, this.availablePeople);
      await this.getImagesForPeople();
      await this.getImagesForAvailablePeople();
      //   console.log(this.availablePeople);
    },
    async getImagesForPeople() {
      for (const t in this.onlinePeople) {
        try {
          let res = await this.getImageUsrId(this.onlinePeople[t].usr_id);
          this.$set(this.onlinePeople[t], "imageURL", res);
        } catch (error) {
          this.handleError(error);
        }
      }
    },
    async getImagesForAvailablePeople() {
      for (const t in this.availablePeople) {
        let id = this.availablePeople[t].usr_id;
        try {
          let res = await this.getImageUsrId(id);
          this.$set(this.availablePeople[t], "imageURL", res);
        } catch (error) {
          this.handleError(error);
        }
      }
    },
    closeOnline() {
      this.$emit("close");
    },
    goToChat(profile) {
      let obj = {
        location: "dm",
        userId: profile.usr_id,
      };
      this.EventBus.$emit("chatProp", obj);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@mixin flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

$online-height: 380px;
$online-width: 230px;
$online-navbar-height: 40px;

.online-wrap {
  z-index: 51;
  background-color: white;
  padding: 10px;
  height: $online-height;
  width: $online-width;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  border: 1px solid rgb(182, 182, 182);
}

.online-navbar-filler {
  width: 100%;
  height: calc(#{$online-navbar-height} - 10px);
}
.online-navbar {
  @include flex-between;
  position: absolute;
  padding: 0 10px;
  top: 0;
  left: 0;
  border-radius: 10px 10px 0 0;
  height: $online-navbar-height;
  // width: calc(100% - 20px);
  width: 100%;
  background-color: #e3e3e3;
  .material-icons.gray {
    color: #888c8e;
    font-size: 18px;
    cursor: pointer;
  }
  .align-left-navbar {
    @include flex-center();
    span {
      margin-right: 10px;
    }
  }
  .align-right-navbar {
    @include flex-center();
  }
}

.everyone-wrap {
  overflow-y: auto;
  width: calc(100%);
  box-sizing: border-box;
  height: calc(#{$online-height} - 42px); // 40px is the navbar height
}
.title {
  margin-top: 10px;
}
.title::after {
  text-align: left;
  content: "";
  display: block;
  height: 1px;
  width: 90%;
  background: gray;
}
.img-wrap {
  position: relative;
  @include flex-center();
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 50%;
  border: 0.5px rgba(0, 0, 0, 0.118) solid;
  img {
    height: 100%;
    max-width: none;
  }
  .frame {
    position: absolute;
  }
}
.person-wrap {
  cursor: pointer;
  @include flex-start;
  height: 55px;
  width: 100%;
  .icon-dot {
    width: 35px;
    position: relative;
    margin-right: 10px;

    .green-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #69d200;
      position: absolute;
      bottom: 2px;
      right: 2px;
      z-index: 99999;
    }
    .orange-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #d26600;
      position: absolute;
      bottom: 2px;
      right: 2px;
      z-index: 99999;
    }
  }
  span {
    width: calc(90% - 40px);
    font-weight: 300;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>